import { useEffect, useRef } from 'react';

import { retryWorkflow, WorkflowResponse } from 'services/gru/gruApi';
import { logError } from 'services/logging/logging';

export const useGruAutomaticRetry = ({
  currentWorkflow,
  agentName,
}: {
  currentWorkflow: WorkflowResponse | null;
  agentName: string;
}) => {
  const hasRetried = useRef(false);
  useEffect(() => {
    if (!hasRetried.current && currentWorkflow && hasEnrichmentFailure(currentWorkflow)) {
      hasRetried.current = true;
      retryWorkflow(agentName, currentWorkflow.workflow.id).catch(logError);
    }
  }, [agentName, currentWorkflow]);
};

const hasEnrichmentFailure = (workflow: WorkflowResponse): boolean =>
  (console.log(workflow) as any) ||
  workflow.actionResults.some(
    (ar) =>
      ar.payload.action === 'propose_enrichment' &&
      ar.payload.status === 'success' &&
      'payload' in ar.payload &&
      (!('enriched' in (ar.payload?.payload as any)) || (ar.payload.payload as any)?.enriched?.length === 0),
  );
